/**
 * Render this module when the user already has a G2MM profile.
 * The user shouldn't be able to actual change their G2MM profile from here.
 */
define('setup/reserve-g2mm/non-editable/non-editable',['require','knockout','web-urls'],function (require) {
    var ko = require('knockout');
    var webUrls = require('web-urls');

    return function () {
        var self = this;

        self.activate = function (activationData) {
            self.goToMeetMeUrl = ko.observable(webUrls.get('gotoMeetMeUrl'));
            self.profileId = activationData.profileId;
            self.nextUrl = activationData.nextUrl;
        };
    };
});

